import styled, { keyframes } from "styled-components";
import { Link as LinkRrd } from "react-router-dom";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;


export const PlusIcon = styled("div")`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.Primary20};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  transition: all 0.3s ease-in-out;

  i:before {
    transition: all 0.3s ease-in-out;
  }
`;

export const Card = styled("div")`
  padding: 16px;
  color: inherit;
  overflow: hidden;
  border-radius: 16px;
  background-color: white;
  flex-shrink: 0;
  width: 100%;
  height: 338px;
  border: 1px dashed #D1D5DB;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  cursor: pointer;

  &:hover {
    border-color: #8B5CF6;
    box-shadow: 0px 1px 14px rgba(139, 92, 246, 0.1);

    ${PlusIcon}{
      background-color: ${({ theme }) => theme.colors.Primary};

      i:before {
        background-color: white;
      }
    }
  }

  @media(max-width: 767px){
    height: 180px;
  }
`;

export const LoadingOverlay = styled("div")`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(2px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 16px;
`;

export const Link = styled(LinkRrd)`
  text-decoration: none;
  color: inherit;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const Title = styled("h3")`
  font-weight: 600;
  font-size: 18px;
  color: black;
  margin: 0px;
  line-height: 22px;
  text-align: center;
  margin-bottom: 8px;

  @media(min-width: 768px){
    font-size: 18px;
  }
`;

export const Subtitle = styled("p")`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #6B7280;
  text-align: center;
  margin: 0px;
`;

export const Spinner = styled("div")`
  width: 40px;
  height: 40px;
  border: 3px solid #F3F4F6;
  border-top: 3px solid #8B5CF6;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;
